export default function APIReference() {
  return (
    <section>
      <h1 className="text-2xl font-bold mb-6">API Reference</h1>

      <div className="mb-8 px-2 py-3 bg-indigo-50 rounded border-2 border-indigo-100 sticky top-16 lg:top-4 shadow-lg">
        <span className="font-semibold text-gray-700">Base URL:</span>{" "}
        <span className="font-mono text-indigo-700 bg-indigo-100 px-2 py-1 rounded break-all">
          https://whenfin-api.l-uca.com
        </span>
        <div className="text-sm text-gray-600 mt-1">
          All API requests should be directed to this base URL.
        </div>
      </div>

      {/* /register_user */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /register_user
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Register a new user account.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "name": "username",
  "password": "password"
}
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "message": "user added"
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /login */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">/login</span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Log in and receive a JWT token.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "name": "username",
  "password": "password"
}
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "token": "jwt_token",
  "createdAt": "2024-05-30T12:00:00.000Z",
  "accountType": "user"
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /delete_account */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /delete_account
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Delete the authenticated user's
            account.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
Headers: { "Authorization": "Bearer <jwt_token>" }
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "success": true
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /add_project */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /add_project
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Create a new project for the
            authenticated user.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
Headers: { "Authorization": "Bearer <jwt_token>" }
{
  "name": "project_name"
}
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "project": {
    "user": "user_id",
    "name": "project_name",
    "secret": "project_secret"
  }
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /list_projects */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /list_projects
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> List all projects for the
            authenticated user.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
Headers: { "Authorization": "Bearer <jwt_token>" }
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "projects": [
    {
      "user": "user_id",
      "name": "project_name",
      "secret": "project_secret"
    }
  ]
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /delete_project */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /delete_project
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Delete a project for the authenticated
            user.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
Headers: { "Authorization": "Bearer <jwt_token>" }
{
  "name": "project_name"
}
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "success": true
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>

      {/* /send_notification */}
      <div className="overflow-hidden rounded-lg bg-white shadow-sm mb-8 border">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
              POST
            </span>
            <span className="font-mono text-sm text-gray-700">
              /send_notification
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <strong>Description:</strong> Send a notification to a project
            inbox.
          </div>
        </div>
        <div className="bg-gray-100 px-4 py-5 sm:p-6">
          <div className="mb-3">
            <div className="font-semibold text-gray-800 mb-1">Inputs</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "user": "username",
  "project_name": "project_name",
  "project_secret": "project_secret",
  "title": "Notification Title",
  "message": "Notification body"
}
              `}</pre>
            </div>
          </div>
          <div>
            <div className="font-semibold text-gray-800 mb-1">Response</div>
            <div className="bg-gray-900 rounded px-2 py-2 text-xs text-gray-100 overflow-x-auto">
              <pre className="whitespace-pre-wrap mb-0">{`
{
  "valid": true
}
              `}</pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
